import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, BookOpen } from "lucide-react";
import SEO from "@/components/site/SEO";

/**
 * Insights page — temporarily hidden.
 *
 * HL Partnership's Financial Promotions team requires every blog to be
 * pre-approved before it can appear on the live site. Until each article
 * is individually signed off by HLP, this page shows a compliance
 * placeholder rather than the article list. The article content lives on
 * in `/app/frontend/src/data/insights.js` for easy re-enable once approvals
 * come back.
 */
export default function Insights() {
    return (
        <>
            <SEO
                title="Insights & Guides | Acumen Financial Services"
                description="Insights and guides from Acumen Financial Services — currently being reviewed for regulatory approval."
                path="/insights"
            />

            <section className="relative pt-28 pb-24 md:pt-40 md:pb-32 bg-brand-bg">
                <div className="mx-auto max-w-3xl px-6 md:px-10 lg:px-16 text-center">
                    <div className="flex items-center justify-center gap-3 mb-6">
                        <span className="h-px w-10 bg-brand-accent" />
                        <span className="text-xs uppercase tracking-[0.24em] text-brand-accent font-bold">
                            Insights & guides
                        </span>
                        <span className="h-px w-10 bg-brand-accent" />
                    </div>

                    <h1
                        data-testid="insights-placeholder-title"
                        className="font-serif-editorial text-4xl sm:text-5xl lg:text-6xl tracking-tight text-brand-primary leading-[1.05]"
                    >
                        Coming back soon,
                        <br />
                        <em className="italic font-light text-brand-accent">
                            once fully approved.
                        </em>
                    </h1>

                    <p className="mt-8 text-lg text-brand-muted leading-relaxed">
                        Our library of UK mortgage guides is being reviewed by
                        HL Partnership's Financial Promotions team before
                        publication. In the meantime, our advisers are the
                        fastest way to get straight answers about your specific
                        situation.
                    </p>

                    <div className="mt-10 inline-flex flex-col sm:flex-row items-center gap-3">
                        <Link
                            to="/contact"
                            data-testid="insights-placeholder-contact"
                            className="inline-flex items-center gap-2 bg-brand-primary text-white px-6 py-3 rounded-full text-sm font-bold hover:bg-brand-primaryHover transition-colors"
                        >
                            <BookOpen size={16} />
                            Ask an adviser instead
                            <ArrowUpRight size={14} />
                        </Link>
                    </div>
                </div>
            </section>
        </>
    );
}
